import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_@babel+core@7.27.1_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.77.4/node_modules/next/dist/client/script.js");
